import { render } from "./AdminSubSidebar.vue?vue&type=template&id=7f977773&scoped=true"
import script from "./AdminSubSidebar.vue?vue&type=script&lang=js"
export * from "./AdminSubSidebar.vue?vue&type=script&lang=js"

import "./AdminSubSidebar.vue?vue&type=style&index=0&id=7f977773&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f977773"]])

export default __exports__